import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { BASE_URL } from "../../../../constant/apiUrl";
import { darkTheme, lightTheme } from "../../../../theme/Theme";
import { useSelector, useDispatch } from "react-redux";
import InvitationHistoryHeader from "./InvitationHistoryHeader";
import InvitationTable from "./InvitationTable";
import CommonModal from "../../../../utils/CommonModal/CommonModal";
import EditRequestSlider from "./EditRequestSlider";
import Loading from "../../../../utils/Loader";
import { getAPI, patchAPI } from "./../../../../API/ApiService";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
import { formatDate, sortTableData } from "../../../../utils/function";
import PropTyes from "prop-types";
import { setDisplay } from "../../../../slices/adminPageSlice";
import {
  setAppoveModal,
  setFetchPending,
} from "../../../../slices/invitationSlice";
import CommonLayout from "../CommonComponent/CommonLayout";

const InvitationHistory = ({ header, loading, tableData, user }) => {
  const { approveModal, editSlider, fetch, isDeny } = useSelector(
    (store) => store.invitation
  );
  const { flagUser } = useSelector((store) => store.user);

  const dispatch = useDispatch();
  const isDarkTheme = useSelector((state) => state.theme);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState(null);
  const [sponsor, setSponsor] = useState(null);
  const [filterList, setFilterList] = useState([]);
  const [actionData, setActionData] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [access, setAccess] = useState(null);
  const [explanation, setExplanation] = useState("");
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    setFilterList(tableData);
  }, [tableData]);

  useEffect(() => {
    return () => {
      dispatch(setAppoveModal(false));
    };
  }, [dispatch]);

  useEffect(() => {
    let updatedRows = tableData;
    if (filter) {
      updatedRows = updatedRows.filter((row) => {
        return row.status === filter.value;
      });
    }
    if (sponsor) {
      updatedRows = updatedRows.filter(
        (row) => row.sponsorEmail === sponsor.label
      );
    }
    if (organization) {
      updatedRows = updatedRows.filter(
        (row) => row.organization === organization.label
      );
    }
    if (access) {
      updatedRows = updatedRows.filter(
        (row) => row.accessType === access.label
      );
    }
    setFilterList(updatedRows);
  }, [filter, tableData, sponsor, organization, access]);

  const getUniqueOptions = (field) => {
    return [...new Set(tableData.map((row) => row[field]))]
      .map((value, index) => ({
        id: index + 1,
        label: value,
      }))
      .sort((a, b) => a.label?.localeCompare(b.label));
  };

  let fileName = "";

  if (header === "Access history") {
    fileName = "access_history.csv";
  } else if (header === "Access:invitation history") {
    fileName = "invitation_history.csv";
  } else {
    fileName = "pending_approvals.csv";
  }

  const handleExportCsv = () => {
    const csvRows = [];
    const headers = ["FirstName", "LastName", "Email", "SponsorMail"];
    let remainingColumn;
    if (header === "Access history") {
      remainingColumn = [
        "Access Type",
        "Contact",
        "Organization",
        "Grant access",
        "Last Access",
      ];
      headers.push(remainingColumn);
    } else {
      remainingColumn = ["Invitation Status", "Organization", "Country"];
      headers.push(remainingColumn);
    }
    csvRows.push(headers.join(","));
    tableData.forEach((row) => {
      let values = [row.firstName, row.lastName, row.email, row.sponsorEmail];
      let remaingValues;
      if (header === "Access history") {
        remaingValues = [
          row.roleName,
          row.contactNo,
          row.organization,
          row.isGrantedAccess === true ? "Active" : "Inactive",
          formatDate(row.lastModifiedDate),
        ];
        values.push(remaingValues);
      } else {
        values.push([row.status, row.company, row.country]);
      }

      csvRows.push(values.join(","));
    });
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleClose = () => {
    dispatch(setAppoveModal(false));
  };
  const denyhandler = async (status) => {
    if (!actionData?.id) {
      handleClose();
      dispatch(setFetchPending(!fetch));
      showErrorToast(
        "Unable to find the selected request. Please select it again and retry."
      );
      return;
    }
    setModalLoading(true);
    let data;
    if (status === "deny") {
      data = {
        id: actionData?.id,
        denyReason: explanation,
        status: "REJECTED",
        actionTakenBy: flagUser.name,
      };
    } else {
      data = {
        id: actionData?.id,
        status: "APPROVED",
        actionTakenBy: flagUser.name,
      };
    }
    try {
      const response = await patchAPI(
        `${BASE_URL}/admin/access-request-form/update-pending-request`,
        data
      );
      if (response?.status === 200) {
        handleClose();
        if (status === "deny") {
          setExplanation("");
          showSuccessToast("You have successfully denied the request");
        } else {
          showSuccessToast("You have successfully approved the request");
        }

        dispatch(setFetchPending(!fetch));
      } else {
        showErrorToast(
          response?.message ||
            response?.data?.message ||
            "Failed to update the request."
        );
        if (response?.status === 409) {
          handleClose();
        }
      }
    } catch (error) {
      console.log(error, "errorr----");
    } finally {
      setModalLoading(false);
    }
  };

  return (
    <CommonLayout>
      {/* <DividerComponent /> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : lightTheme.backgroundColorLayer2,
        }}
        data-testid="access-history"
      >
        <InvitationHistoryHeader
          user={user}
          setSearch={setSearchText}
          handleExportCsv={handleExportCsv}
          header={header}
          getUniqueOptions={getUniqueOptions}
          setFilter={setFilter}
          setSponsor={setSponsor}
          setOrganization={setOrganization}
          setAccess={setAccess}
        />
      </Box>
      <InvitationTable
        searchText={searchText}
        rows={filterList}
        header={header}
        setActionData={setActionData}
        user={user}
        loading={loading}
      />
      {approveModal && (
        <CommonModal
          data-testid="approve-modal"
          isDeny={isDeny}
          handleClose={handleClose}
          setExplanation={setExplanation}
          denyhandler={denyhandler}
          explanation={explanation}
          approveModal={approveModal}
          loading={modalLoading}
        />
      )}
      {editSlider && <EditRequestSlider actionData={actionData} />}
    </CommonLayout>
  );
};

export default InvitationHistory;

InvitationHistory.propTypes = {
  header: PropTyes.string,
};
